import { render } from "./PassportRegisterForm.vue?vue&type=template&id=c04b11b0&scoped=true"
import script from "./PassportRegisterForm.vue?vue&type=script&lang=js"
export * from "./PassportRegisterForm.vue?vue&type=script&lang=js"

import "./PassportRegisterForm.vue?vue&type=style&index=0&id=c04b11b0&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c04b11b0"]])

export default __exports__